/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const MissedCall = (props: IconProps) => (
  <Icon {...props}>
    <g clipPath="url(#clip0_6146_19492)">
      <path d="M6.5 5.5L12 11L19 4L18 3L12 9L7.5 4.5H11V3H5V9H6.5V5.5ZM23.71 16.67C20.66 13.78 16.54 12 12 12C7.46 12 3.34 13.78 0.29 16.67C0.11 16.85 0 17.1 0 17.38C0 17.66 0.11 17.91 0.29 18.09L2.77 20.57C2.95 20.75 3.2 20.86 3.48 20.86C3.75 20.86 4 20.75 4.18 20.58C4.97 19.84 5.87 19.22 6.84 18.73C7.17 18.57 7.4 18.23 7.4 17.83V14.73C8.85 14.25 10.4 14 12 14C13.6 14 15.15 14.25 16.6 14.72V17.82C16.6 18.21 16.83 18.56 17.16 18.72C18.14 19.21 19.03 19.84 19.83 20.57C20.01 20.75 20.26 20.85 20.53 20.85C20.81 20.85 21.06 20.74 21.24 20.56L23.72 18.08C23.9 17.9 24.01 17.65 24.01 17.37C24.01 17.09 23.89 16.85 23.71 16.67V16.67Z" />
    </g>
    <defs>
      <clipPath id="clip0_6146_19492">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);
